// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  border: 1px solid var(--ion-color-medium);
  display: block;
  background: var(--mc-surface-0);
  max-width: 968px;
}

:host:isEditing {
  border-bottom: 2px solid var(--ion-color-primary);
}

.signature-pad-clear:before {
  content: "\\e5cd";
  color: var(--ion-color-lighter-light);
  font-family: "icomoon" !important;
  font-size: 18px;
  line-height: 14px;
  margin: 0 auto;
  margin-left: -1px;
}
.signature-pad-clear {
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  position: absolute;
  right: 15px;
  top: 15px;
  padding: 8px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.signature-pad-modify:before {
  content: "\\e254";
  color: var(--ion-color-lighter-light);
  font-family: "icomoon" !important;
  font-size: 18px;
  line-height: 14px;
  margin: 0 auto;
  margin-left: -1px;
}
.signature-pad-modify {
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  position: absolute;
  right: 10px;
  top: 15px;
  padding: 8px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/signature/signature.component.scss"],"names":[],"mappings":"AAAA;EAEC,WAAA;EACA,yCAAA;EACA,cAAA;EACA,+BAAA;EACA,gBAAA;AAAD;;AAEA;EACC,iDAAA;AACD;;AAGC;EACC,gBAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAAF;AARA;EAUC,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACD;;AAGC;EACC,gBAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAAF;AARA;EAUC,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACD","sourcesContent":[":host {\r\n\t// margin-top: 8px;\r\n\twidth: 100%;\r\n\tborder: 1px solid var(--ion-color-medium);\r\n\tdisplay: block;\r\n\tbackground: var(--mc-surface-0);\r\n\tmax-width: 968px;\r\n}\r\n:host:isEditing {\r\n\tborder-bottom: 2px solid var(--ion-color-primary);\r\n}\r\n\r\n.signature-pad-clear {\r\n\t&:before {\r\n\t\tcontent: \"\\e5cd\";\r\n\t\tcolor: var(--ion-color-lighter-light);\r\n\t\tfont-family: \"icomoon\" !important;\r\n\t\tfont-size: 18px;\r\n\t\tline-height: 14px;\r\n\t\tmargin: 0 auto;\r\n\t\tmargin-left: -1px;\r\n\t}\r\n\tbackground: rgba(0, 0, 0, 0.5);\r\n\ttext-align: center;\r\n\tposition: absolute;\r\n\tright: 15px;\r\n\ttop: 15px;\r\n\tpadding: 8px;\r\n\tborder-radius: 50%;\r\n\twidth: 32px;\r\n\theight: 32px;\r\n}\r\n\r\n.signature-pad-modify {\r\n\t&:before {\r\n\t\tcontent: \"\\e254\";\r\n\t\tcolor: var(--ion-color-lighter-light);\r\n\t\tfont-family: \"icomoon\" !important;\r\n\t\tfont-size: 18px;\r\n\t\tline-height: 14px;\r\n\t\tmargin: 0 auto;\r\n\t\tmargin-left: -1px;\r\n\t}\r\n\tbackground: rgba(0, 0, 0, 0.5);\r\n\ttext-align: center;\r\n\tposition: absolute;\r\n\tright: 10px;\r\n\ttop: 15px;\r\n\tpadding: 8px;\r\n\tborder-radius: 50%;\r\n\twidth: 32px;\r\n\theight: 32px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
